import { HttpParams } from '@angular/common/http';

export const createRequestOption = (req?: any): HttpParams => {
  req = req ? executeParams(req) : req;
  let options: HttpParams = new HttpParams();
  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort' && req[key] !== undefined && key !== 'searchParams') {
        options = options.set(key, req[key]);
      }
    });
    if (req.sort) {
      req.sort.forEach(val => {
        options = options.append('sort', val);
      });
    }
    req.searchParams && Object.keys(req.searchParams).forEach(key => {
      options = options.set(key, req.searchParams[key]);
    });
  }
  return options;
};
export const createRequestBody = (req?: any): HttpParams => {
  req = req ? executeParams(req) : req;
  let options: any = {};
  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort' && req[key] !== undefined && key !== 'searchParams') {
        options[key] = req[key];
      }
    });
    req.searchParams && Object.keys(req.searchParams).forEach(key => {
      options[key] = req.searchParams[key];
    });
  }
  return options;
};
export const executeParams = (params?: any) => {
  if (!params.searchParams) {
    return params;
  }
  const keys = Object.keys(params.searchParams);
    keys.forEach((key) => {
      if (typeof params.searchParams[key] === 'string') {
        params.searchParams[key] = params.searchParams[key].trim();
        if (params.searchParams[key] === 'undefined') {
          params.searchParams[key] = undefined;
        }
      }
    });
  return params;
};
